var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUploadFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8193 1.6875H5.06543C4.13677 1.6875 3.3854 2.44731 3.3854 3.37598L3.37695 16.8838C3.37695 17.8125 4.12832 18.5723 5.05699 18.5723H15.1963C16.125 18.5723 16.8848 17.8125 16.8848 16.8838V6.75293L11.8193 1.6875ZM15.1963 16.8838H5.06543V3.37598H10.9751V7.59717H15.1963V16.8838ZM6.75391 12.671L7.94428 13.8614L9.28662 12.5275V16.0396H10.9751V12.5275L12.3174 13.8699L13.5078 12.671L10.1393 9.28564L6.75391 12.671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadFile);
export default __webpack_public_path__ + "static/media/icon_upload_file.06f7e28449cb3a3fa0bfc497093bdec1.svg";
export { ForwardRef as ReactComponent };